﻿import React, { useState, useMemo } from 'react'
import { Link, useLocation } from 'react-router-dom'
import { Button } from './ui'
import UserConfigModal from './UserConfigModal'
import { 
  HomeIcon, 
  UsersIcon, 
  ArrowLeftOnRectangleIcon,
  Bars3Icon,
  XMarkIcon,
  ServerIcon,
  DocumentTextIcon,
  DocumentIcon,
  DocumentArrowUpIcon,
  ChatBubbleLeftRightIcon,
  LightBulbIcon,
  SparklesIcon,
  BookOpenIcon,
  ChatBubbleOvalLeftEllipsisIcon,
  ChevronDownIcon,
  ChevronRightIcon,
  FolderIcon,
  ChevronLeftIcon,
  ChevronRightIcon as ChevronRightIconOutline,
  Cog6ToothIcon,
  CalendarDaysIcon,
  ChartBarIcon,
  ShoppingBagIcon,
  BoltIcon,
  MagnifyingGlassIcon,
  TagIcon,
  EyeIcon,
  UserIcon,
  EnvelopeIcon,
  PhoneIcon,
  MapPinIcon,
  GlobeAltIcon,
  ShieldCheckIcon,
  KeyIcon,
  LockClosedIcon,
  ClipboardDocumentIcon,
  PresentationChartLineIcon,
  BanknotesIcon,
  BuildingOfficeIcon,
  BriefcaseIcon,
  CommandLineIcon,
  CpuChipIcon,
  DevicePhoneMobileIcon,
  FilmIcon,
  PhotoIcon,
  VideoCameraIcon,
  MusicalNoteIcon,
  PaintBrushIcon,
  PuzzlePieceIcon,
  RocketLaunchIcon,
  StarIcon,
  HeartIcon,
  FireIcon,
  SunIcon,
  MoonIcon,
  CloudIcon,
  WrenchScrewdriverIcon,
  LinkIcon,
  ArrowPathIcon,
  CheckCircleIcon,
  ExclamationTriangleIcon,
  InformationCircleIcon,
  QuestionMarkCircleIcon,
  AcademicCapIcon,
  BeakerIcon,
  ClipboardIcon,
  CubeIcon,
  CubeTransparentIcon,
  CurrencyDollarIcon,
  DocumentDuplicateIcon,
  FunnelIcon,
  GiftIcon,
  HandRaisedIcon,
  HashtagIcon,
  IdentificationIcon,
  InboxIcon,
  ListBulletIcon,
  NewspaperIcon,
  PaperClipIcon,
  PaperAirplaneIcon,
  PencilSquareIcon,
  PrinterIcon,
  QueueListIcon,
  RectangleStackIcon,
  Squares2X2Icon,
  SwatchIcon,
  TableCellsIcon,
  TicketIcon,
  WifiIcon,
  WindowIcon,
  AdjustmentsHorizontalIcon,
  ArchiveBoxIcon,
  ArrowDownTrayIcon,
  ArrowUpTrayIcon,
  Bars4Icon,
  BuildingLibraryIcon,
  CalculatorIcon,
  CameraIcon,
  ChartPieIcon,
  ClockIcon,
  CloudArrowDownIcon,
  CloudArrowUpIcon,
  CodeBracketIcon,
  CodeBracketSquareIcon,
  ComputerDesktopIcon,
  CreditCardIcon,
  CursorArrowRaysIcon,
  EllipsisHorizontalIcon,
  EllipsisVerticalIcon,
  EnvelopeOpenIcon,
  FaceSmileIcon,
  FingerPrintIcon,
  FlagIcon,
  FolderOpenIcon,
  ForwardIcon,
  HandThumbUpIcon,
  HandThumbDownIcon,
  LanguageIcon,
  LifebuoyIcon,
  MegaphoneIcon,
  MicrophoneIcon,
  MinusIcon,
  NoSymbolIcon,
  PauseIcon,
  PlayIcon,
  PlayCircleIcon,
  PlusCircleIcon,
  PowerIcon,
  QrCodeIcon,
  RadioIcon,
  ReceiptPercentIcon,
  ShareIcon,
  SignalIcon,
  SpeakerWaveIcon,
  SpeakerXMarkIcon,
  StopIcon,
  TvIcon,
  WalletIcon,
  XCircleIcon
} from '@heroicons/react/24/outline'
import { resolveModuleIcon } from '../utils/moduleIconResolver'
import { CameraIcon as CameraIconSolid } from '@heroicons/react/24/solid'
import { useTheme } from '../hooks'
import NotificationBadge from './notifications/NotificationBadge'
import NotificationMenu from './notifications/NotificationMenu'
import { useNotifications } from '../hooks/useNotifications'
import { useAuthContext } from '../contexts/AuthContext'
import { getSignedAvatarUrl } from '../services/avatar'
import { modulesService } from '../services/modules'
import type { ModuleWithPermissions } from '../types'
import { APP_VERSION } from '../constants/appVersion'

// Ícone do WhatsApp personalizado
const WhatsAppIcon = ({ className }: { className?: string }) => (
  <svg className={className} viewBox="0 0 24 24" fill="currentColor">
    <path d="M17.472 14.382c-.297-.149-1.758-.867-2.03-.967-.273-.099-.471-.148-.67.15-.197.297-.767.966-.94 1.164-.173.199-.347.223-.644.075-.297-.15-1.255-.463-2.39-1.475-.883-.788-1.48-1.761-1.653-2.059-.173-.297-.018-.458.13-.606.134-.133.298-.347.446-.52.149-.174.198-.298.298-.497.099-.198.05-.371-.025-.52-.075-.149-.669-1.612-.916-2.207-.242-.579-.487-.5-.669-.51-.173-.008-.371-.01-.57-.01-.198 0-.52.074-.792.372-.272.297-1.04 1.016-1.04 2.479 0 1.462 1.065 2.875 1.213 3.074.149.198 2.096 3.2 5.077 4.487.709.306 1.262.489 1.694.625.712.227 1.36.195 1.871.118.571-.085 1.758-.719 2.006-1.413.248-.694.248-1.289.173-1.413-.074-.124-.272-.198-.57-.347m-5.421 7.403h-.004a9.87 9.87 0 01-5.031-1.378l-.361-.214-3.741.982.998-3.648-.235-.374a9.86 9.86 0 01-1.51-5.26c.001-5.45 4.436-9.884 9.888-9.884 2.64 0 5.122 1.03 6.988 2.898a9.825 9.825 0 012.893 6.994c-.003 5.45-4.437 9.884-9.885 9.884m8.413-18.297A11.815 11.815 0 0012.05 0C5.495 0 .16 5.335.157 11.892c0 2.096.547 4.142 1.588 5.945L.057 24l6.305-1.654a11.882 11.882 0 005.683 1.448h.005c6.554 0 11.89-5.335 11.893-11.893A11.821 11.821 0 0020.885 3.488"/>
  </svg>
)

// Ícones de App/Aplicativo personalizados
const AppIcon = ({ className }: { className?: string }) => (
  <svg className={className} viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
    <rect x="4" y="2" width="16" height="20" rx="2" />
    <line x1="9" y1="6" x2="15" y2="6" />
    <line x1="9" y1="10" x2="15" y2="10" />
    <line x1="9" y1="14" x2="13" y2="14" />
  </svg>
)

const AppMobileIcon = ({ className }: { className?: string }) => (
  <svg className={className} viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
    <rect x="5" y="2" width="14" height="20" rx="2" />
    <circle cx="12" cy="18" r="1" />
    <line x1="8" y1="6" x2="16" y2="6" />
  </svg>
)

const AppDesktopIcon = ({ className }: { className?: string }) => (
  <svg className={className} viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
    <rect x="2" y="3" width="20" height="14" rx="2" />
    <line x1="8" y1="21" x2="16" y2="21" />
    <line x1="12" y1="17" x2="12" y2="21" />
    <line x1="6" y1="8" x2="18" y2="8" />
  </svg>
)

const AppGridIcon = ({ className }: { className?: string }) => (
  <svg className={className} viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
    <rect x="3" y="3" width="7" height="7" rx="1" />
    <rect x="14" y="3" width="7" height="7" rx="1" />
    <rect x="3" y="14" width="7" height="7" rx="1" />
    <rect x="14" y="14" width="7" height="7" rx="1" />
  </svg>
)

// Ícones de Usuários personalizados
const UserCircleIcon = ({ className }: { className?: string }) => (
  <svg className={className} viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
    <circle cx="12" cy="8" r="4" />
    <path d="M6 21c0-3.314 2.686-6 6-6s6 2.686 6 6" />
  </svg>
)

const UserGroupIcon = ({ className }: { className?: string }) => (
  <svg className={className} viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
    <circle cx="9" cy="7" r="3" />
    <path d="M2 21c0-2.5 2-4.5 4.5-4.5h5c2.5 0 4.5 2 4.5 4.5" />
    <circle cx="17" cy="7" r="3" />
    <path d="M22 21c0-2.5-2-4.5-4.5-4.5h-1.5" />
  </svg>
)

const UserSquareIcon = ({ className }: { className?: string }) => (
  <svg className={className} viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
    <rect x="3" y="3" width="18" height="18" rx="2" />
    <circle cx="12" cy="10" r="3" />
    <path d="M7 21c0-2.5 2.5-5 5-5s5 2.5 5 5" />
  </svg>
)

// Ícones de Servidores personalizados
const ServerStackIcon = ({ className }: { className?: string }) => (
  <svg className={className} viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
    <rect x="2" y="2" width="20" height="6" rx="1" />
    <rect x="2" y="10" width="20" height="6" rx="1" />
    <rect x="2" y="18" width="20" height="6" rx="1" />
    <line x1="6" y1="5" x2="6" y2="5" strokeWidth="3" />
    <line x1="6" y1="13" x2="6" y2="13" strokeWidth="3" />
    <line x1="6" y1="21" x2="6" y2="21" strokeWidth="3" />
  </svg>
)

const ServerCloudIcon = ({ className }: { className?: string }) => (
  <svg className={className} viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
    <path d="M18 10h-1.26A8 8 0 1 0 9 20h9a5 5 0 0 0 0-10z" />
    <rect x="4" y="12" width="12" height="8" rx="1" />
    <line x1="8" y1="16" x2="8" y2="16" strokeWidth="2" />
  </svg>
)

const ServerDatabaseIcon = ({ className }: { className?: string }) => (
  <svg className={className} viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
    <ellipse cx="12" cy="5" rx="9" ry="3" />
    <path d="M3 5v14c0 1.66 4.03 3 9 3s9-1.34 9-3V5" />
    <path d="M3 12c0 1.66 4.03 3 9 3s9-1.34 9-3" />
    <line x1="6" y1="8" x2="6" y2="8" strokeWidth="3" />
    <line x1="6" y1="12" x2="6" y2="12" strokeWidth="3" />
  </svg>
)

// Ícones de Dashboard personalizados
const DashboardIcon = ({ className }: { className?: string }) => (
  <svg className={className} viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
    <rect x="3" y="3" width="7" height="7" rx="1" />
    <rect x="14" y="3" width="7" height="7" rx="1" />
    <rect x="3" y="14" width="7" height="7" rx="1" />
    <rect x="14" y="14" width="7" height="7" rx="1" />
  </svg>
)

const DashboardGridIcon = ({ className }: { className?: string }) => (
  <svg className={className} viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
    <rect x="2" y="2" width="9" height="9" rx="1" />
    <rect x="13" y="2" width="9" height="9" rx="1" />
    <rect x="2" y="13" width="9" height="9" rx="1" />
    <rect x="13" y="13" width="9" height="9" rx="1" />
    <line x1="7" y1="2" x2="7" y2="22" />
    <line x1="18" y1="2" x2="18" y2="22" />
    <line x1="2" y1="7" x2="22" y2="7" />
    <line x1="2" y1="18" x2="22" y2="18" />
  </svg>
)

const DashboardChartIcon = ({ className }: { className?: string }) => (
  <svg className={className} viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
    <rect x="3" y="3" width="18" height="18" rx="2" />
    <line x1="7" y1="12" x2="7" y2="16" />
    <line x1="11" y1="10" x2="11" y2="16" />
    <line x1="15" y1="8" x2="15" y2="16" />
    <line x1="19" y1="6" x2="19" y2="16" />
    <line x1="3" y1="16" x2="21" y2="16" />
  </svg>
)

const DashboardAnalyticsIcon = ({ className }: { className?: string }) => (
  <svg className={className} viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
    <rect x="3" y="3" width="18" height="18" rx="2" />
    <path d="M7 16l4-4 4 4 4-4" />
    <line x1="3" y1="16" x2="21" y2="16" />
    <line x1="7" y1="20" x2="7" y2="16" />
    <line x1="11" y1="20" x2="11" y2="12" />
    <line x1="15" y1="20" x2="15" y2="8" />
    <line x1="19" y1="20" x2="19" y2="4" />
  </svg>
)

// Ícones de Configurações personalizados
const SettingsGearIcon = ({ className }: { className?: string }) => (
  <svg className={className} viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
    <path d="M12 15a3 3 0 1 0 0-6 3 3 0 0 0 0 6z" />
    <path d="M19.4 15a1.65 1.65 0 0 0 .33 1.82l.06.06a2 2 0 0 1 0 2.83 2 2 0 0 1-2.83 0l-.06-.06a1.65 1.65 0 0 0-1.82-.33 1.65 1.65 0 0 0-1 1.51V21a2 2 0 0 1-2 2 2 2 0 0 1-2-2v-.09A1.65 1.65 0 0 0 9 19.4a1.65 1.65 0 0 0-1.82.33l-.06.06a2 2 0 0 1-2.83 0 2 2 0 0 1 0-2.83l.06-.06a1.65 1.65 0 0 0 .33-1.82 1.65 1.65 0 0 0-1.51-1H3a2 2 0 0 1-2-2 2 2 0 0 1 2-2h.09A1.65 1.65 0 0 0 4.6 9a1.65 1.65 0 0 0-.33-1.82l-.06-.06a2 2 0 0 1 0-2.83 2 2 0 0 1 2.83 0l.06.06a1.65 1.65 0 0 0 1.82.33H9a1.65 1.65 0 0 0 1-1.51V3a2 2 0 0 1 2-2 2 2 0 0 1 2 2v.09a1.65 1.65 0 0 0 1 1.51 1.65 1.65 0 0 0 1.82-.33l.06-.06a2 2 0 0 1 2.83 0 2 2 0 0 1 0 2.83l-.06.06a1.65 1.65 0 0 0-.33 1.82V9a1.65 1.65 0 0 0 1.51 1H21a2 2 0 0 1 2 2 2 2 0 0 1-2 2h-.09a1.65 1.65 0 0 0-1.51 1z" />
  </svg>
)

const SettingsSlidersIcon = ({ className }: { className?: string }) => (
  <svg className={className} viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
    <line x1="4" y1="21" x2="4" y2="14" />
    <line x1="4" y1="10" x2="4" y2="3" />
    <line x1="12" y1="21" x2="12" y2="12" />
    <line x1="12" y1="8" x2="12" y2="3" />
    <line x1="20" y1="21" x2="20" y2="16" />
    <line x1="20" y1="12" x2="20" y2="3" />
    <line x1="1" y1="14" x2="7" y2="14" />
    <line x1="9" y1="8" x2="15" y2="8" />
    <line x1="17" y1="16" x2="23" y2="16" />
  </svg>
)

const SettingsAdjustmentsIcon = ({ className }: { className?: string }) => (
  <svg className={className} viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
    <circle cx="6" cy="10" r="2" />
    <line x1="6" y1="12" x2="6" y2="20" />
    <line x1="6" y1="8" x2="6" y2="4" />
    <circle cx="12" cy="6" r="2" />
    <line x1="12" y1="8" x2="12" y2="4" />
    <line x1="12" y1="12" x2="12" y2="20" />
    <circle cx="18" cy="14" r="2" />
    <line x1="18" y1="16" x2="18" y2="20" />
    <line x1="18" y1="12" x2="18" y2="4" />
    <line x1="8" y1="10" x2="10" y2="10" />
    <line x1="14" y1="6" x2="16" y2="6" />
    <line x1="16" y1="14" x2="20" y2="14" />
  </svg>
)

const SettingsCogIcon = ({ className }: { className?: string }) => (
  <svg className={className} viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
    <circle cx="12" cy="12" r="3" />
    <path d="M12 1v6m0 6v6M5.64 5.64l4.24 4.24m4.24 4.24l4.24 4.24M1 12h6m6 0h6M5.64 18.36l4.24-4.24m4.24-4.24l4.24-4.24" />
  </svg>
)

// Ícones de Notificações personalizados
const NotificationBellIcon = ({ className }: { className?: string }) => (
  <svg className={className} viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
    <path d="M18 8A6 6 0 0 0 6 8c0 7-3 9-3 9h18s-3-2-3-9" />
    <path d="M13.73 21a2 2 0 0 1-3.46 0" />
  </svg>
)

const NotificationBellAlertIcon = ({ className }: { className?: string }) => (
  <svg className={className} viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
    <path d="M18 8A6 6 0 0 0 6 8c0 7-3 9-3 9h18s-3-2-3-9" />
    <path d="M13.73 21a2 2 0 0 1-3.46 0" />
    <circle cx="18" cy="6" r="3" fill="currentColor" />
  </svg>
)

const NotificationBellRingIcon = ({ className }: { className?: string }) => (
  <svg className={className} viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
    <path d="M6 8a6 6 0 0 1 11.901 1.5c0 3.2-2.5 5.5-5.5 5.5s-5.5-2.3-5.5-5.5A6 6 0 0 1 6 8z" />
    <path d="M13.73 21a2 2 0 0 1-3.46 0" />
    <path d="M2 2l4 4M22 2l-4 4" />
  </svg>
)

const NotificationBadgeIcon = ({ className }: { className?: string }) => (
  <svg className={className} viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
    <path d="M18 8A6 6 0 0 0 6 8c0 7-3 9-3 9h18s-3-2-3-9" />
    <path d="M13.73 21a2 2 0 0 1-3.46 0" />
    <circle cx="18" cy="5" r="4" fill="currentColor" />
  </svg>
)

const NotificationMessageIcon = ({ className }: { className?: string }) => (
  <svg className={className} viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
    <path d="M21 11.5a8.38 8.38 0 0 1-.9 3.8 8.5 8.5 0 0 1-7.6 4.7 8.38 8.38 0 0 1-3.8-.9L3 21l1.9-5.7a8.38 8.38 0 0 1-.9-3.8 8.5 8.5 0 0 1 4.7-7.6 8.38 8.38 0 0 1 3.8-.9h.5a8.48 8.48 0 0 1 8 8v.5z" />
    <circle cx="18" cy="6" r="2" fill="currentColor" />
  </svg>
)

interface MenuItem {
  name: string
  icon: React.ComponentType<{ className?: string }>
  path?: string  // Tornar opcional para itens com submenu
  children?: MenuItem[]  // Adicionar suporte a submenu
}

const OPEN_GROUPS_KEY = 'qg-sidebar-open-groups'

const readOpenGroups = (): Set<string> => {
  try {
    const raw = localStorage.getItem(OPEN_GROUPS_KEY)
    if (!raw) return new Set()
    const parsed = JSON.parse(raw)
    if (!Array.isArray(parsed)) return new Set()
    const names = parsed.filter((n): n is string => typeof n === 'string')
    if (names.length === 0) return new Set()
    return new Set([names[names.length - 1]])
  } catch {
    return new Set()
  }
}

const exclusiveOpenGroups = (name: string | null): Set<string> => {
  const next = name ? new Set([name]) : new Set<string>()
  writeOpenGroups(next)
  return next
}

const writeOpenGroups = (groups: Set<string>) => {
  try {
    localStorage.setItem(OPEN_GROUPS_KEY, JSON.stringify(Array.from(groups)))
  } catch {
    /* noop */
  }
}

// Mapa de ícones por nome salvo no banco
export const getIconByName = (name?: string) => {
  switch ((name || '').toLowerCase()) {
    case 'home':
    case 'home-icon':
      return HomeIcon
    // Ícones de Usuários
    case 'users':
      return UsersIcon
    case 'user-circle':
      return UserCircleIcon
    case 'user-group':
      return UserGroupIcon
    case 'user-square':
      return UserSquareIcon
    // Ícones de Servidores
    case 'server':
      return ServerIcon
    case 'server-stack':
      return ServerStackIcon
    case 'server-cloud':
      return ServerCloudIcon
    case 'server-database':
      return ServerDatabaseIcon
    // Ícones de App
    case 'app':
      return AppIcon
    case 'app-mobile':
      return AppMobileIcon
    case 'app-desktop':
      return AppDesktopIcon
    case 'app-grid':
      return AppGridIcon
    case 'document-text':
      return DocumentTextIcon
    case 'document':
      return DocumentIcon
    case 'document-arrow-up':
      return DocumentArrowUpIcon
    case 'chat-bubble-left-right':
      return ChatBubbleLeftRightIcon
    case 'light-bulb':
      return LightBulbIcon
    case 'sparkles':
      return SparklesIcon
    case 'book-open':
      return BookOpenIcon
    case 'chat-bubble-oval-left-ellipsis':
      return ChatBubbleOvalLeftEllipsisIcon
    case 'cog-6-tooth':
      return Cog6ToothIcon
    // Ícones de Dashboard
    case 'dashboard':
      return DashboardIcon
    case 'dashboard-grid':
      return DashboardGridIcon
    case 'dashboard-chart':
      return DashboardChartIcon
    case 'dashboard-analytics':
      return DashboardAnalyticsIcon
    // Ícones de Configurações
    case 'settings':
    case 'settings-gear':
      return SettingsGearIcon
    case 'settings-sliders':
      return SettingsSlidersIcon
    case 'settings-adjustments':
      return SettingsAdjustmentsIcon
    case 'settings-cog':
      return SettingsCogIcon
    // Ícones de Notificações
    case 'notification':
    case 'notification-bell':
      return NotificationBellIcon
    case 'notification-bell-alert':
      return NotificationBellAlertIcon
    case 'notification-bell-ring':
      return NotificationBellRingIcon
    case 'notification-badge':
      return NotificationBadgeIcon
    case 'notification-message':
      return NotificationMessageIcon
    case 'calendar-days':
      return CalendarDaysIcon
    case 'chart-bar':
      return ChartBarIcon
    case 'whatsapp':
      return WhatsAppIcon
    // Ícones de Shop
    case 'shopping-bag':
    case 'shop':
      return ShoppingBagIcon
    // Ícones adicionais do Heroicons
    case 'bolt':
      return BoltIcon
    case 'magnifying-glass':
      return MagnifyingGlassIcon
    case 'tag':
      return TagIcon
    case 'eye':
      return EyeIcon
    case 'user':
      return UserIcon
    case 'envelope':
      return EnvelopeIcon
    case 'phone':
      return PhoneIcon
    case 'map-pin':
      return MapPinIcon
    case 'globe-alt':
      return GlobeAltIcon
    case 'shield-check':
      return ShieldCheckIcon
    case 'key':
      return KeyIcon
    case 'lock-closed':
      return LockClosedIcon
    case 'clipboard-document':
      return ClipboardDocumentIcon
    case 'presentation-chart-line':
      return PresentationChartLineIcon
    case 'banknotes':
      return BanknotesIcon
    case 'building-office':
      return BuildingOfficeIcon
    case 'briefcase':
      return BriefcaseIcon
    case 'command-line':
      return CommandLineIcon
    case 'cpu-chip':
      return CpuChipIcon
    case 'device-phone-mobile':
      return DevicePhoneMobileIcon
    case 'film':
      return FilmIcon
    case 'photo':
      return PhotoIcon
    case 'video-camera':
      return VideoCameraIcon
    case 'camera':
      return CameraIcon
    case 'musical-note':
      return MusicalNoteIcon
    case 'paint-brush':
      return PaintBrushIcon
    case 'puzzle-piece':
      return PuzzlePieceIcon
    case 'rocket-launch':
      return RocketLaunchIcon
    case 'star':
      return StarIcon
    case 'heart':
      return HeartIcon
    case 'fire':
      return FireIcon
    case 'sun':
      return SunIcon
    case 'moon':
      return MoonIcon
    case 'cloud':
      return CloudIcon
    case 'cloud-arrow-down':
      return CloudArrowDownIcon
    case 'cloud-arrow-up':
      return CloudArrowUpIcon
    case 'wrench-screwdriver':
      return WrenchScrewdriverIcon
    case 'link':
      return LinkIcon
    case 'arrow-path':
      return ArrowPathIcon
    case 'check-circle':
      return CheckCircleIcon
    case 'exclamation-triangle':
      return ExclamationTriangleIcon
    case 'information-circle':
      return InformationCircleIcon
    case 'question-mark-circle':
      return QuestionMarkCircleIcon
    case 'x-circle':
      return XCircleIcon
    case 'academic-cap':
      return AcademicCapIcon
    case 'beaker':
      return BeakerIcon
    case 'clipboard':
      return ClipboardIcon
    case 'cube':
      return CubeIcon
    case 'cube-transparent':
      return CubeTransparentIcon
    case 'currency-dollar':
      return CurrencyDollarIcon
    case 'document':
      return DocumentIcon
    case 'document-arrow-up':
      return DocumentArrowUpIcon
    case 'document-duplicate':
      return DocumentDuplicateIcon
    case 'funnel':
      return FunnelIcon
    case 'gift':
      return GiftIcon
    case 'hand-raised':
      return HandRaisedIcon
    case 'hand-thumb-up':
      return HandThumbUpIcon
    case 'hand-thumb-down':
      return HandThumbDownIcon
    case 'hashtag':
      return HashtagIcon
    case 'identification':
      return IdentificationIcon
    case 'inbox':
      return InboxIcon
    case 'list-bullet':
      return ListBulletIcon
    case 'newspaper':
      return NewspaperIcon
    case 'paper-clip':
      return PaperClipIcon
    case 'paper-airplane':
      return PaperAirplaneIcon
    case 'pencil-square':
      return PencilSquareIcon
    case 'printer':
      return PrinterIcon
    case 'queue-list':
      return QueueListIcon
    case 'rectangle-stack':
      return RectangleStackIcon
    case 'squares-2x2':
      return Squares2X2Icon
    case 'swatch':
      return SwatchIcon
    case 'table-cells':
      return TableCellsIcon
    case 'ticket':
      return TicketIcon
    case 'wifi':
      return WifiIcon
    case 'window':
      return WindowIcon
    case 'adjustments-horizontal':
      return AdjustmentsHorizontalIcon
    case 'archive-box':
      return ArchiveBoxIcon
    case 'arrow-down-tray':
      return ArrowDownTrayIcon
    case 'arrow-up-tray':
      return ArrowUpTrayIcon
    case 'bars-3':
      return Bars3Icon
    case 'bars-4':
      return Bars4Icon
    case 'building-library':
      return BuildingLibraryIcon
    case 'calculator':
      return CalculatorIcon
    case 'chart-pie':
      return ChartPieIcon
    case 'clock':
      return ClockIcon
    case 'code-bracket':
      return CodeBracketIcon
    case 'code-bracket-square':
      return CodeBracketSquareIcon
    case 'computer-desktop':
      return ComputerDesktopIcon
    case 'credit-card':
      return CreditCardIcon
    case 'cursor-arrow-rays':
      return CursorArrowRaysIcon
    case 'ellipsis-horizontal':
      return EllipsisHorizontalIcon
    case 'ellipsis-vertical':
      return EllipsisVerticalIcon
    case 'envelope-open':
      return EnvelopeOpenIcon
    case 'face-smile':
      return FaceSmileIcon
    case 'finger-print':
      return FingerPrintIcon
    case 'flag':
      return FlagIcon
    case 'folder-open':
      return FolderOpenIcon
    case 'forward':
      return ForwardIcon
    case 'language':
      return LanguageIcon
    case 'lifebuoy':
      return LifebuoyIcon
    case 'megaphone':
      return MegaphoneIcon
    case 'microphone':
      return MicrophoneIcon
    case 'minus':
      return MinusIcon
    case 'no-symbol':
      return NoSymbolIcon
    case 'pause':
      return PauseIcon
    case 'play':
      return PlayIcon
    case 'play-circle':
      return PlayCircleIcon
    case 'plus-circle':
      return PlusCircleIcon
    case 'power':
      return PowerIcon
    case 'qr-code':
      return QrCodeIcon
    case 'radio':
      return RadioIcon
    case 'receipt-percent':
      return ReceiptPercentIcon
    case 'share':
      return ShareIcon
    case 'signal':
      return SignalIcon
    case 'speaker-wave':
      return SpeakerWaveIcon
    case 'speaker-x-mark':
      return SpeakerXMarkIcon
    case 'stop':
      return StopIcon
    case 'tv':
      return TvIcon
    case 'wallet':
      return WalletIcon
    case 'bell':
      return resolveModuleIcon('bell') ?? FolderIcon
    case 'folder':
      return FolderIcon
    default:
      return resolveModuleIcon(name) ?? FolderIcon
  }
}

const LOGO_EYES_EXPANDED = [
  { left: '6.21%', top: '29.83%', width: '4.44%', height: '18.78%' },
  { left: '18.26%', top: '29.83%', width: '4.44%', height: '18.78%' },
]
const LOGO_EYES_COLLAPSED = [
  { left: '21.44%', top: '34.03%', width: '15.32%', height: '14.87%' },
  { left: '63.02%', top: '34.03%', width: '15.32%', height: '14.87%' },
]

const Sidebar: React.FC = () => {
  const { darkMode, toggleDarkMode } = useTheme()
  const location = useLocation()
  const { user, profile, signOut } = useAuthContext()
  const [isMobileMenuOpen, setIsMobileMenuOpen] = useState(false)
  const [openSubmenus, setOpenSubmenus] = useState<Set<string>>(() => readOpenGroups())
  const [isUserConfigModalOpen, setIsUserConfigModalOpen] = useState(false)
  const [isNotificationsOpen, setIsNotificationsOpen] = useState(false)
  const { unreadCount, items, markAsRead, deleteOne, clearAll } = useNotifications()
  const [isCollapsed, setIsCollapsed] = useState(() => {
    try {
      return localStorage.getItem('qg-sidebar-collapsed') === 'true'
    } catch {
      return false
    }
  })
  const [avatarUrl, setAvatarUrl] = useState<string | null>(null)
  const [menuItems, setMenuItems] = useState<MenuItem[]>([])
  const [searchTerm, setSearchTerm] = useState<string>('')
  const [logoAnimId, setLogoAnimId] = useState(0)
  const logoAnimatingRef = React.useRef(false)
  const logoAnimTimerRef = React.useRef<number | null>(null)
  const [isUserMenuOpen, setIsUserMenuOpen] = useState(false)
  const userMenuRef = React.useRef<HTMLDivElement>(null)
  const navRef = React.useRef<HTMLElement>(null)
  const pendingParentAlignRef = React.useRef<{ name: string; offsetInView: number } | null>(null)

  React.useEffect(() => {
    return () => {
      if (logoAnimTimerRef.current != null) window.clearTimeout(logoAnimTimerRef.current)
    }
  }, [])

  // Fechar menu do usuário ao clicar fora
  React.useEffect(() => {
    const handleClickOutside = (e: MouseEvent) => {
      if (userMenuRef.current && !userMenuRef.current.contains(e.target as Node)) {
        setIsUserMenuOpen(false)
      }
    }
    if (isUserMenuOpen) {
      document.addEventListener('mousedown', handleClickOutside)
      return () => document.removeEventListener('mousedown', handleClickOutside)
    }
  }, [isUserMenuOpen])

  // Carregar URL assinada do avatar quando mudar
  React.useEffect(() => {
    let cancelled = false
    const load = async () => {
      if (!profile?.avatar_url) {
        setAvatarUrl(null)
        return
      }
      const url = await getSignedAvatarUrl(profile.avatar_url)
      if (!cancelled) setAvatarUrl(url)
    }
    load()
    return () => { cancelled = true }
  }, [profile?.avatar_url])

  // Montar árvore Pai→Filhos a partir dos módulos (respeitando order_index)
  const buildMenuTree = React.useCallback((mods: ModuleWithPermissions[]): MenuItem[] => {
    const byId = new Map<string, ModuleWithPermissions & { children: ModuleWithPermissions[] }>(
      mods.map(m => [m.id, { ...m, children: [] }])
    )
    const roots: (ModuleWithPermissions & { children: ModuleWithPermissions[] })[] = []

    byId.forEach((m) => {
      if (m.parent_module_id && byId.has(m.parent_module_id)) {
        byId.get(m.parent_module_id)!.children.push(m)
      } else {
        roots.push(m)
      }
    })

    const sortFn = (a: any, b: any) => (a.order_index ?? 1e9) - (b.order_index ?? 1e9)
    byId.forEach((n) => n.children.sort(sortFn))
    roots.sort(sortFn)

    // Filtrar por can_show: filhos precisam can_show; pais entram se eles mesmos tem can_show ou algum filho visível
    const toMenuItem = (node: ModuleWithPermissions & { children: ModuleWithPermissions[] }): MenuItem | null => {
      const Icon = getIconByName(node.icon)
      // node.children já contém elementos com children porque foram criados em byId
      const visibleChildren = node.children
        .map((c) => {
          // Buscar o nó completo do byId que garante ter children
          const fullNode = byId.get(c.id)
          return fullNode ? toMenuItem(fullNode) : null
        })
        .filter(Boolean) as MenuItem[]

      const isLeafVisible = !!node.can_show && (!node.children || node.children.length === 0)
      const parentVisible = !!node.can_show || visibleChildren.length > 0

      // Nome exibido no menu: sempre do cadastro do módulo (display_name), com fallback
      const menuLabel = (node.display_name || node.name || '—').trim()
      if (node.children.length > 0) {
        // Nó pai (container). Exibir se tiver can_show ou tiver filho visível
        if (!parentVisible) return null
        return {
          name: menuLabel,
          icon: Icon,
          children: visibleChildren
        }
      } else {
        // Folha: exibir apenas se can_show
        if (!isLeafVisible) return null
        return {
          name: menuLabel,
          icon: Icon,
          path: node.route || '#'
        }
      }
    }

    const result: MenuItem[] = []
    for (const r of roots) {
      const item = toMenuItem(r)
      if (item) result.push(item)
    }
    return result
  }, [])

  // Carregar módulos com permissões do grupo do usuário e montar menu
  React.useEffect(() => {
    let cancelled = false
    const load = async () => {
      if (!profile?.user_group_id) {
        setMenuItems([])
        return
      }
      const { data, error } = await modulesService.getActiveWithPermissionsByGroup(profile.user_group_id)
      if (error) {
        setMenuItems([])
        return
      }
      const tree = buildMenuTree(data || [])
      if (!cancelled) {
        setMenuItems(tree)
        // Remover nomes de grupos que não existem mais no menu
        const validNames = new Set(
          tree.filter(item => item.children && item.children.length > 0).map(item => item.name)
        )
        setOpenSubmenus(prev => {
          const valid = Array.from(prev).filter(name => validNames.has(name))
          const kept = valid.length > 0 ? valid[valid.length - 1] : null
          const next = kept ? new Set([kept]) : new Set<string>()
          const unchanged = next.size === prev.size && Array.from(next).every(name => prev.has(name))
          if (unchanged) return prev
          writeOpenGroups(next)
          return next
        })
      }
    }
    load()
    return () => { cancelled = true }
  }, [profile?.user_group_id, buildMenuTree])

  // Rota atual abre só o pai correspondente e retrai os demais
  React.useEffect(() => {
    if (menuItems.length === 0) return
    const currentPath = location.pathname
    const parent = menuItems.find(
      item => item.children && item.children.some(c => c.path === currentPath)
    )
    if (!parent) return
    setOpenSubmenus(prev => {
      if (prev.size === 1 && prev.has(parent.name)) return prev
      return exclusiveOpenGroups(parent.name)
    })
  }, [location.pathname, menuItems])

  // Função para filtrar itens do menu baseado no termo de busca
  const filterMenuItems = (items: MenuItem[], term: string): MenuItem[] => {
    if (!term.trim()) return items

    const lowerTerm = term.toLowerCase()
    
    return items
      .map(item => {
        const itemNameMatches = item.name.toLowerCase().includes(lowerTerm)
        
        // Se tem filhos, filtrar os filhos também
        if (item.children) {
          const filteredChildren = item.children.filter(child => 
            child.name.toLowerCase().includes(lowerTerm)
          )
          
          // Incluir o item se o nome dele ou algum filho corresponder
          if (itemNameMatches || filteredChildren.length > 0) {
            return {
              ...item,
              children: filteredChildren
            }
          }
          return null
        }
        
        // Item sem filhos: incluir se o nome corresponder
        return itemNameMatches ? item : null
      })
      .filter((item): item is MenuItem => item !== null)
  }

  const filteredMenuItems = useMemo(() => {
    return filterMenuItems(menuItems, searchTerm)
  }, [menuItems, searchTerm])

  // Itens do menu seguem padrão atual: proteção ocorre na página via PermissionGuard

  const getInitials = (user: any) => {
    if (!user) return 'U'
    
    // Usar o nome do perfil se disponível, senão usar email
    const name = profile?.name || user.email || ''
    const words = name.split(' ')
    
    if (words.length >= 2) {
      return (words[0][0] + words[1][0]).toUpperCase()
    } else if (name.length > 0) {
      return name[0].toUpperCase()
    }
    
    return 'U'
  }

  const handleSignOut = async () => {
    await signOut()
  }

  const isActive = (path: string) => {
    return location.pathname === path
  }

  const hasActiveChild = (children?: MenuItem[]) => {
    return children?.some(child => child.path && isActive(child.path))
  }

  const queueParentAlign = (name: string, button: HTMLElement) => {
    const nav = navRef.current
    if (!nav) return
    pendingParentAlignRef.current = {
      name,
      offsetInView: button.getBoundingClientRect().top - nav.getBoundingClientRect().top
    }
  }

  // Ao abrir/fechar um pai a altura da lista muda; recoloca o item clicado na mesma posição visível.
  React.useLayoutEffect(() => {
    const pending = pendingParentAlignRef.current
    if (!pending) return
    pendingParentAlignRef.current = null

    const nav = navRef.current
    if (!nav) return

    const selector = `[data-menu-parent="${CSS.escape(pending.name)}"]`
    const button = nav.querySelector<HTMLElement>(selector)
    if (!button) return

    const currentOffset = button.getBoundingClientRect().top - nav.getBoundingClientRect().top
    nav.scrollTop += currentOffset - pending.offsetInView
  }, [openSubmenus, isCollapsed])

  // Manter o item da rota atual visível só na troca de página / recarga do menu — nunca ao abrir um pai.
  React.useEffect(() => {
    if (menuItems.length === 0 || searchTerm.trim()) return

    let cancelled = false
    let timeoutId = 0
    let frame1 = 0
    let frame2 = 0

    const scrollActiveIntoView = () => {
      if (cancelled || pendingParentAlignRef.current) return
      const nav = navRef.current
      if (!nav) return

      const activeEl = nav.querySelector<HTMLElement>('[data-menu-active="true"]')
      if (!activeEl) return

      const navRect = nav.getBoundingClientRect()
      const elRect = activeEl.getBoundingClientRect()
      const fullyVisible = elRect.top >= navRect.top && elRect.bottom <= navRect.bottom
      if (fullyVisible) return

      const delta = elRect.top - navRect.top - (nav.clientHeight / 2) + (elRect.height / 2)
      nav.scrollTop += delta
    }

    timeoutId = window.setTimeout(() => {
      frame1 = requestAnimationFrame(() => {
        frame2 = requestAnimationFrame(scrollActiveIntoView)
      })
    }, 0)

    return () => {
      cancelled = true
      window.clearTimeout(timeoutId)
      cancelAnimationFrame(frame1)
      cancelAnimationFrame(frame2)
    }
  }, [location.pathname, menuItems, searchTerm])

  React.useEffect(() => {
    const isMobile = window.innerWidth < 1024
    if (isMobile) {
      document.body.classList.add('mobile-layout')
    } else {
      document.body.classList.remove('mobile-layout')
    }
    
    const handleResize = () => {
      const isMobileNow = window.innerWidth < 1024
      if (isMobileNow) {
        document.body.classList.add('mobile-layout')
      } else {
        document.body.classList.remove('mobile-layout')
      }
    }
    
    window.addEventListener('resize', handleResize)
    return () => window.removeEventListener('resize', handleResize)
  }, [])

  // Fechar drawer mobile ao navegar (layout persistente não remonta o Sidebar)
  React.useEffect(() => {
    setIsMobileMenuOpen(false)
  }, [location.pathname])

  // O painel de notificações é portal no body; no mobile ele precisa fechar com o drawer.
  const wasMobileMenuOpenRef = React.useRef(false)
  React.useEffect(() => {
    if (wasMobileMenuOpenRef.current && !isMobileMenuOpen) {
      setIsNotificationsOpen(false)
    }
    wasMobileMenuOpenRef.current = isMobileMenuOpen
  }, [isMobileMenuOpen])

  // Se ainda está carregando, mostrar skeleton
  if (!user) {
    return null
  }

  return (
    <>
      {/* Mobile header with menu button */}
      <div className="lg:hidden fixed top-0 left-0 right-0 z-50 bg-white dark:bg-gray-900 border-b border-gray-200 dark:border-gray-700">
        <div className="relative flex items-center px-2 py-2 min-h-[3rem]">
          <Button
            variant="ghost"
            size="sm"
            onClick={() => setIsMobileMenuOpen(!isMobileMenuOpen)}
            className="relative z-10 shrink-0 !p-2 mr-auto"
            aria-label={isMobileMenuOpen ? 'Fechar menu' : 'Abrir menu'}
          >
            {isMobileMenuOpen ? (
              <XMarkIcon className="h-6 w-6" />
            ) : (
              <Bars3Icon className="h-6 w-6" />
            )}
          </Button>
          <img
            src="/Logo_QG_PASI-06.png"
            alt="QG PASI Logo"
            className="pointer-events-none absolute left-1/2 top-1/2 h-[1.701rem] w-auto -translate-x-1/2 -translate-y-1/2 origin-center scale-[1.049] object-contain"
          />
        </div>
      </div>


      {/* Sidebar */}
      <div className={`
        fixed inset-y-0 left-0 z-40 overflow-hidden bg-white dark:bg-gray-900 border-r border-gray-200 dark:border-gray-700
        transform transition-all duration-300 ease-in-out
        ${isCollapsed ? 'w-16' : 'w-64'}
        ${isMobileMenuOpen ? 'translate-x-0' : '-translate-x-full lg:translate-x-0'}
      `}>
        <div className="flex h-full min-h-0 flex-col">
          {/* Header - área fixa */}
          <div className={`relative flex flex-shrink-0 items-center justify-center overflow-visible border-b border-gray-200 bg-gray-50 dark:border-gray-700 dark:bg-gray-800 ${isCollapsed ? 'px-2 py-3' : 'px-4 py-3'}`}>
            <div
              className="relative origin-center scale-[1.049]"
              onMouseEnter={() => {
                if (logoAnimatingRef.current) return
                if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) return
                logoAnimatingRef.current = true
                setLogoAnimId((id) => id + 1)
                if (logoAnimTimerRef.current != null) window.clearTimeout(logoAnimTimerRef.current)
                logoAnimTimerRef.current = window.setTimeout(() => {
                  logoAnimatingRef.current = false
                  setLogoAnimId(0)
                  logoAnimTimerRef.current = null
                }, 1200)
              }}
            >
              {logoAnimId > 0 && (
                <div
                  key={`logo-glow-${logoAnimId}`}
                  aria-hidden
                  className="pointer-events-none absolute inset-0 animate-robot-glow motion-reduce:animate-none dark:hidden"
                  style={{
                    background:
                      'radial-gradient(circle at 50% 40%, rgba(255,255,255,0.25) 0%, transparent 65%)',
                  }}
                />
              )}
              <div
                key={logoAnimId}
                className={`relative ${logoAnimId > 0 ? 'animate-menu-logo-hover motion-reduce:animate-none' : ''}`}
                onAnimationEnd={(event) => {
                  if (event.animationName !== 'robotBlink') return
                  if (logoAnimTimerRef.current != null) {
                    window.clearTimeout(logoAnimTimerRef.current)
                    logoAnimTimerRef.current = null
                  }
                  logoAnimatingRef.current = false
                  setLogoAnimId(0)
                }}
              >
                <img
                  src={isCollapsed ? '/Logo_QG_PASI.png' : '/Logo_QG_PASI-06.png'}
                  alt="QG PASI Logo"
                  className={`object-contain ${isCollapsed ? 'h-[1.944rem] w-[1.944rem]' : 'h-[1.944rem] w-auto max-w-[9.72rem]'}`}
                />
                {logoAnimId > 0 &&
                  (isCollapsed ? LOGO_EYES_COLLAPSED : LOGO_EYES_EXPANDED).map((eye) => (
                    <span
                      key={`${eye.left}-${eye.width}`}
                      aria-hidden
                      className="pointer-events-none absolute origin-center rounded-full bg-gray-50 animate-robot-blink motion-reduce:hidden dark:bg-gray-800"
                      style={eye}
                    />
                  ))}
              </div>
            </div>
          </div>

          {/* Navigation */}
          <nav
            ref={navRef}
            style={{ scrollBehavior: 'auto', overflowAnchor: 'none' }}
            className={`min-h-0 flex-1 space-y-1 overflow-y-auto overflow-anchor-none scroll-auto pt-2 pb-6 ${isCollapsed ? 'px-2' : 'px-4'}`}
          >
            {/* Campo de busca */}
            {!isCollapsed && (
              <div className="mb-1.5 px-2">
                <div className="relative">
                  <MagnifyingGlassIcon className="absolute left-3 top-1/2 transform -translate-y-1/2 h-4 w-4 text-gray-400 dark:text-gray-500" />
                  <input
                    type="text"
                    placeholder="Buscar no menu..."
                    value={searchTerm}
                    onChange={(e) => setSearchTerm(e.target.value)}
                    className="w-full pl-10 pr-4 py-2 text-sm border-0 rounded-lg bg-gray-50 dark:bg-gray-800 text-gray-900 dark:text-white placeholder-gray-500 dark:placeholder-gray-400 focus:outline-none focus:ring-2 focus:ring-primary-500"
                  />
                  {searchTerm && (
                    <button
                      onClick={() => setSearchTerm('')}
                      className="absolute right-3 top-1/2 transform -translate-y-1/2 text-gray-400 dark:text-gray-500 hover:text-gray-600 dark:hover:text-gray-300"
                      aria-label="Limpar busca"
                    >
                      <XMarkIcon className="h-4 w-4" />
                    </button>
                  )}
                </div>
              </div>
            )}
            
            {filteredMenuItems.length === 0 && searchTerm ? (
              <div className="px-2 py-4 text-center">
                <p className="text-sm text-gray-500 dark:text-gray-400">
                  Nenhum item encontrado
                </p>
              </div>
            ) : (
              filteredMenuItems.map((item) => {
              const Icon = item.icon
              // Busca: abrir só na UI (pais com filhos filtrados). Sem busca: Set persistido.
              const isSubmenuOpen = searchTerm.trim()
                ? !!(item.children && item.children.length > 0)
                : openSubmenus.has(item.name)
              const hasActiveChildItem = hasActiveChild(item.children)
              
              // Se tem submenu
              if (item.children) {
                return (
                  <div key={item.name}>
                    <button
                      type="button"
                      data-menu-parent={item.name}
                      onMouseDown={(e) => {
                        e.preventDefault()
                        e.currentTarget.focus({ preventScroll: true })
                      }}
                      onClick={(e) => {
                        queueParentAlign(item.name, e.currentTarget)
                        if (isCollapsed) {
                          // Se estiver retraído, expandir o menu primeiro
                          setIsCollapsed(false)
                          try { localStorage.setItem('qg-sidebar-collapsed', 'false') } catch { /* noop */ }
                          // Aguardar um pouco para a animação e depois abrir o submenu
                          setTimeout(() => {
                            queueParentAlign(item.name, e.currentTarget)
                            setOpenSubmenus(() => exclusiveOpenGroups(item.name))
                          }, 150)
                        } else {
                          setOpenSubmenus(prev => {
                            const isOnlyOpen = prev.size === 1 && prev.has(item.name)
                            return exclusiveOpenGroups(isOnlyOpen ? null : item.name)
                          })
                        }
                      }}
                      className={`
                        w-full flex items-center ${isCollapsed ? 'justify-center px-2' : 'justify-between px-3'} py-2 rounded-lg text-sm transition-colors
                        ${hasActiveChildItem
                          ? 'bg-primary-50 dark:bg-primary-900/20 text-primary-500 dark:text-primary-400 font-bold'
                          : 'text-gray-700 dark:text-gray-300 hover:bg-gray-100 dark:hover:bg-gray-800 font-medium'
                        }
                      `}
                      data-menu-active={isCollapsed && hasActiveChildItem ? 'true' : undefined}
                      title={isCollapsed ? item.name : undefined}
                    >
                      <div className={`flex items-center ${isCollapsed ? '' : 'space-x-3'}`}>
                        <Icon className="h-5 w-5" />
                        {!isCollapsed && <span>{item.name}</span>}
                      </div>
                      {!isCollapsed && (
                        isSubmenuOpen ? (
                          <ChevronDownIcon className="h-4 w-4" />
                        ) : (
                          <ChevronRightIcon className="h-4 w-4" />
                        )
                      )}
                    </button>
                    
                    {/* Submenu items */}
                    {isSubmenuOpen && !isCollapsed && (
                      <div className="ml-3 mt-0.5 space-y-0.5 rounded-lg bg-gray-50 px-1.5 py-1 dark:bg-gray-700">
                        {item.children.map((child) => {
                          const ChildIcon = child.icon
                          return (
                            <Link
                              key={child.path || child.name}
                              to={child.path || '#'}
                              data-menu-active={child.path && isActive(child.path) ? 'true' : undefined}
                              className={`
                                flex items-center space-x-3 px-3 py-2 rounded-lg text-sm transition-colors
                                ${child.path && isActive(child.path)
                                  ? 'bg-primary-50 dark:bg-primary-900/20 text-primary-500 dark:text-primary-400 font-bold'
                                  : 'text-gray-600 dark:text-gray-300 hover:bg-gray-100 dark:hover:bg-gray-600 font-medium'
                                }
                              `}
                            >
                              <ChildIcon className="h-4 w-4" />
                              <span>{child.name}</span>
                            </Link>
                          )
                        })}
                      </div>
                    )}
                  </div>
                )
              }
              
              // Se não tem submenu (item normal)
              return (
                <Link
                  key={item.path || item.name}
                  to={item.path || '#'}
                  data-menu-active={item.path && isActive(item.path) ? 'true' : undefined}
                  className={`
                    flex items-center ${isCollapsed ? 'justify-center px-2' : 'space-x-3 px-3'} py-2 rounded-lg text-sm transition-colors
                    ${item.path && isActive(item.path)
                      ? 'bg-primary-50 dark:bg-primary-900/20 text-primary-500 dark:text-primary-400 font-bold'
                      : 'text-gray-700 dark:text-gray-300 hover:bg-gray-100 dark:hover:bg-gray-800 font-medium'
                    }
                  `}
                  title={isCollapsed ? item.name : undefined}
                >
                  <Icon className="h-5 w-5" />
                  {!isCollapsed && <span>{item.name}</span>}
                </Link>
              )
              })
            )}
            
            {/* Mobile logout button inside menu */}
            <div className="lg:hidden mt-4 pt-4 border-t border-gray-200 dark:border-gray-700">
              <Button
                variant="ghost"
                onClick={handleSignOut}
                className="w-full justify-start text-gray-700 dark:text-gray-300 hover:bg-gray-100 dark:hover:bg-gray-800"
              >
                <ArrowLeftOnRectangleIcon className="h-5 w-5 mr-3" />
                Sair
              </Button>
            </div>
          </nav>

          {/* Parte inferior - avatar e nome do usuário (área fixa) */}
          <div ref={userMenuRef} className="px-4 pt-1 pb-0.5 border-t border-gray-200 dark:border-gray-700 flex-shrink-0 mt-auto relative flex flex-col items-center justify-center bg-gray-100 dark:bg-gray-800">
            <button
              type="button"
              onClick={() => {
                if (isCollapsed) {
                  setIsUserConfigModalOpen(true)
                } else {
                  setIsUserMenuOpen(prev => !prev)
                }
              }}
              className={`rounded-lg hover:bg-gray-100 dark:hover:bg-gray-800 transition-colors focus:outline-none p-1 -m-1 ${
                isCollapsed ? 'flex flex-col items-center' : 'flex items-center gap-2'
              }`}
              title={isCollapsed ? 'Atualizar dados e foto' : 'Clique para abrir o menu'}
            >
              <div className="relative flex-shrink-0 w-10 h-10">
                <div className="absolute inset-0 rounded-full overflow-hidden bg-gradient-to-r from-primary-500 to-purple-600 flex items-center justify-center">
                  {avatarUrl ? (
                    <img src={avatarUrl} alt="Avatar" className="w-full h-full object-cover" />
                  ) : (
                    <span className="text-white font-semibold text-sm">{getInitials(user)}</span>
                  )}
                </div>
                {!avatarUrl && (
                  <span className="absolute -bottom-0.5 -right-0.5 w-4 h-4 bg-white dark:bg-gray-800 rounded-full flex items-center justify-center shadow ring-1 ring-gray-200 dark:ring-gray-600">
                    <CameraIconSolid className="h-2.5 w-2.5 text-gray-600 dark:text-gray-400" />
                  </span>
                )}
                <NotificationBadge count={unreadCount} />
              </div>
              {isCollapsed && (
                <span className="mt-0.5 text-[8px] leading-none text-gray-400 dark:text-gray-500">
                  v{APP_VERSION}
                </span>
              )}
              {!isCollapsed && (
                <div className="min-w-0 overflow-hidden flex items-center gap-1">
                  <div className="min-w-0 flex-1">
                    <p className="text-sm font-medium text-gray-900 dark:text-white truncate">
                      {profile?.name || user.email}
                    </p>
                    <p className="text-xs text-gray-500 dark:text-gray-400 truncate">
                      {user.email}
                    </p>
                  </div>
                  <ChevronDownIcon className={`h-4 w-4 flex-shrink-0 text-gray-500 transition-transform ${isUserMenuOpen ? 'rotate-180' : ''}`} />
                </div>
              )}
            </button>
            {!isCollapsed && (
              <div className="mt-1 w-full text-center text-[9px] leading-tight text-gray-400 dark:text-gray-500">
                v{APP_VERSION}
              </div>
            )}
            {!isCollapsed && isUserMenuOpen && (
              <div className="absolute left-4 right-4 bottom-full mb-1 py-1 bg-gray-100 dark:bg-gray-800 rounded-lg shadow-lg border border-gray-200 dark:border-gray-700 z-50">
                <button
                  type="button"
                  onClick={() => {
                    setIsUserMenuOpen(false)
                    setIsNotificationsOpen(true)
                  }}
                  className="w-full flex items-center gap-2 px-3 py-2 text-sm text-left text-gray-700 dark:text-gray-300 hover:bg-gray-200 dark:hover:bg-gray-700"
                >
                  <NotificationBellIcon className="h-4 w-4" />
                  Notificações
                  {unreadCount > 0 && (
                    <span className="ml-auto inline-flex items-center justify-center rounded-full bg-red-500 text-white text-xs font-bold min-w-[18px] h-[18px] px-1">
                      {unreadCount > 99 ? '99+' : unreadCount}
                    </span>
                  )}
                </button>
                <button
                  type="button"
                  onClick={() => {
                    setIsUserMenuOpen(false)
                    toggleDarkMode()
                  }}
                  className="w-full flex items-center gap-2 px-3 py-2 text-sm text-left text-gray-700 dark:text-gray-300 hover:bg-gray-200 dark:hover:bg-gray-700"
                >
                  {darkMode ? (
                    <>
                      <SunIcon className="h-4 w-4" />
                      Modo claro
                    </>
                  ) : (
                    <>
                      <MoonIcon className="h-4 w-4" />
                      Modo escuro
                    </>
                  )}
                </button>
                <button
                  type="button"
                  onClick={() => {
                    setIsUserMenuOpen(false)
                    setIsUserConfigModalOpen(true)
                  }}
                  className="w-full flex items-center gap-2 px-3 py-2 text-sm text-left text-gray-700 dark:text-gray-300 hover:bg-gray-200 dark:hover:bg-gray-700"
                >
                  <UserCircleIcon className="h-4 w-4" />
                  Atualizar Dados e Foto
                </button>
                <button
                  type="button"
                  onClick={() => {
                    setIsUserMenuOpen(false)
                    handleSignOut()
                  }}
                  className="w-full flex items-center gap-2 px-3 py-2 text-sm text-left text-red-600 dark:text-red-400 hover:bg-red-50 dark:hover:bg-red-900/20"
                >
                  <ArrowLeftOnRectangleIcon className="h-4 w-4" />
                  Sair
                </button>
              </div>
            )}
            {/* Menu de Notificações */}
            {isNotificationsOpen && (
              <NotificationMenu
                items={items}
                anchorRef={userMenuRef}
                onMarkAsRead={async (id: string) => { await markAsRead(id) }}
                onDelete={async (id: string) => { await deleteOne(id) }}
                onClearAll={async () => { await clearAll() }}
                onClose={() => setIsNotificationsOpen(false)}
              />
            )}
          </div>
        </div>
      </div>

      <div
        className={`pointer-events-none fixed inset-y-0 left-0 z-50 hidden transition-[width] duration-300 ease-in-out lg:block ${isCollapsed ? 'w-16' : 'w-64'}`}
      >
        <button
          type="button"
          onClick={() => {
            const next = !isCollapsed
            setIsCollapsed(next)
            try { localStorage.setItem('qg-sidebar-collapsed', String(next)) } catch { /* noop */ }
          }}
          title={isCollapsed ? 'Expandir menu' : 'Retrair menu'}
          aria-label={isCollapsed ? 'Expandir menu' : 'Retrair menu'}
          className="pointer-events-auto absolute right-0 top-[1.75rem] flex h-7 w-7 -translate-y-1/2 translate-x-1/2 items-center justify-center rounded-full border border-gray-200 bg-white text-gray-600 shadow-md outline-none transition-colors hover:bg-gray-50 focus:outline-none dark:border-gray-600 dark:bg-gray-800 dark:text-gray-300 dark:hover:bg-gray-700"
        >
          {isCollapsed ? (
            <ChevronRightIconOutline className="h-3.5 w-3.5" />
          ) : (
            <ChevronLeftIcon className="h-3.5 w-3.5" />
          )}
        </button>
      </div>

      {/* Overlay for mobile */}
      {isMobileMenuOpen && (
        <div
          className="fixed inset-0 bg-black bg-opacity-50 z-30 lg:hidden"
          onClick={() => setIsMobileMenuOpen(false)}
        />
      )}

      {/* Main content margin and mobile padding */}
      <div className={`pt-16 lg:pt-0 ${isCollapsed ? 'lg:ml-16' : 'lg:ml-64'}`} />

      {/* User Config Modal */}
      <UserConfigModal
        isOpen={isUserConfigModalOpen}
        onClose={() => setIsUserConfigModalOpen(false)}
      />
    </>
  )
}

export default Sidebar
